import { useEffect } from "react";
import moment from "moment";

export default function useDateCellClasses({ currentView, calendarBaseDate, events }) {
  useEffect(() => {
    const updateDateCellClasses = () => {
      const today = moment().startOf("day");
      const cells = document.querySelectorAll(".rbc-date-cell");
      if (cells.length !== 42) return;
      const startDate = moment(calendarBaseDate).startOf("month").startOf("week");
      cells.forEach((cell, index) => {
        const cellDate = moment(startDate).add(index, "days");
        cell.classList.remove("passed", "future");
        if (cellDate.isBefore(today, "day")) cell.classList.add("passed");
        else if (cellDate.isAfter(today, "day")) cell.classList.add("future");
      });
    };

    const timeout = setTimeout(() => {
      updateDateCellClasses();
      const calendarMonthView = document.querySelector(".rbc-month-view");
      if (!calendarMonthView) return;
      const observer = new MutationObserver(() => updateDateCellClasses());
      observer.observe(calendarMonthView, { childList: true, subtree: true });
      return () => observer.disconnect();
    }, 100);

    return () => clearTimeout(timeout);
  }, [currentView, calendarBaseDate]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const today = moment().startOf("day");
      const cells = document.querySelectorAll(".rbc-date-cell");
      const startDate = moment(calendarBaseDate).startOf("month").startOf("week");
      cells.forEach((cell, index) => {
        const cellDate = moment(startDate).add(index, "days");
        cell.classList.remove("passed", "future");
        if (cellDate.isBefore(today, "day")) cell.classList.add("passed");
        else if (cellDate.isAfter(today, "day")) cell.classList.add("future");
      });
    }, 50);
    return () => clearTimeout(timeout);
  }, [calendarBaseDate, currentView, events]);
}

